"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _useMediaQuery = _interopRequireDefault(require("../../hooks/useMediaQuery"));
var _ = _interopRequireDefault(require("."));
const QueryContextProvider = ({
  children
}) => {
  const value = (0, _useMediaQuery.default)();
  return /*#__PURE__*/React.createElement(_.default.Provider, {
    value: value
  }, children);
};
var _default = exports.default = QueryContextProvider;